function updateCountdown() {
  const now = new Date();
  const targetTime = window.NEXT_WEBINAR;
  const timeDiff = targetTime - now;

  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor(timeDiff / (1000 * 60));
  const seconds = Math.floor(timeDiff / 1000);

  updateWheel(document.getElementById('countdownDays'), days);
  updateWheel(document.getElementById('countdownHours'), hours);
  updateWheel(document.getElementById('countdownMinutes'), minutes);
  updateWheel(document.getElementById('countdownSeconds'), seconds);
}

function updateWheel(el, number) {
  el.children[0].style.setProperty('--val', Math.floor(number / 10));
  el.children[1].style.setProperty('--val', number);
}

setInterval(updateCountdown, 1000);
updateCountdown();


var container = document.documentElement
var lastHeight = 0;

new ResizeObserver(function() {
  const newHeight = container.offsetHeight;

  if (lastHeight !== newHeight) {
    lastHeight = newHeight;

    window.parent.postMessage(
      JSON.stringify({
        src: window.location.toString(),
        context: "iframe.resize",
        height: newHeight
      }),
      "*"
    );
  }
}).observe(container);
